import { render, staticRenderFns } from "./UserRepresentative.vue?vue&type=template&id=9245197c&"
import script from "./UserRepresentative.vue?vue&type=script&lang=ts&"
export * from "./UserRepresentative.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports